import { c as _c } from "react/compiler-runtime";
import VideoIcon from '@/components/assets/icon_trailer_video.svg';
import OptimizedImage from '@/components/OptimizedImage';
import { MEDIA_TYPE } from '@/hooks/useTrailerViewMedia';
import thumbnailDefaultIcon from '@/public/images/thumbnail_default.png';
import { RefObject } from 'react';
interface MediaItem {
  url: string;
  type: string;
  isConverted?: boolean;
  coverImage?: string;
}
interface TrailerThumbnailItemProps {
  item: MediaItem;
  index: number;
  currentIndex: number;
  thumbWidth: number;
  handleClick: (index: number) => void;
  thumbnailRef: RefObject<(HTMLDivElement | null)[]>;
  updateScrollFade: () => void;
  imgErrorArr: boolean[];
  handleImgError: (idx: number) => void;
}
const TrailerThumbnailItem = t0 => {
  const $ = _c(29);
  const {
    item,
    index,
    currentIndex,
    thumbWidth,
    handleClick,
    thumbnailRef,
    updateScrollFade,
    imgErrorArr,
    handleImgError
  } = t0;
  const isActive = currentIndex === index;
  const isVideo = item.type === MEDIA_TYPE.VIDEO;
  const isConverted = item.isConverted;
  let t1;
  if ($[0] !== handleClick || $[1] !== index) {
    t1 = () => handleClick(index);
    $[0] = handleClick;
    $[1] = index;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `w-full transition-all h-full object-cover rounded-lg cursor-pointer ${isActive ? "border-4 border-vive-brand-50" : ""}`;
  let t3;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== updateScrollFade) {
    t3 = {
      onClick: t1,
      className: t2,
      onLoad: updateScrollFade
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = updateScrollFade;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const commonProps = t3;
  let t4;
  if ($[7] !== thumbWidth) {
    t4 = {
      width: thumbWidth
    };
    $[7] = thumbWidth;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `${item.url}-${index}`;
  let t6;
  if ($[9] !== index || $[10] !== thumbnailRef) {
    t6 = el => {
      thumbnailRef.current[index] = el;
    };
    $[9] = index;
    $[10] = thumbnailRef;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== commonProps || $[13] !== handleImgError || $[14] !== imgErrorArr || $[15] !== index || $[16] !== isConverted || $[17] !== isVideo || $[18] !== item.coverImage || $[19] !== item.url) {
    t7 = isVideo ? isConverted ? <OptimizedImage src={imgErrorArr[index] ? thumbnailDefaultIcon : item.coverImage || thumbnailDefaultIcon} alt={`Trailer ${index + 1}`} fill={true} sizes="(max-width: 768px) 100vw, 300px" className={commonProps.className} onError={() => handleImgError(index)} onClick={commonProps.onClick} onLoad={commonProps.onLoad} /> : <video src={item.url} muted={true} autoPlay={true} playsInline={true} controls={false} {...commonProps} /> : <OptimizedImage src={imgErrorArr[index] ? thumbnailDefaultIcon : item.url} alt={`Trailer ${index + 1}`} fill={true} className={commonProps.className} onError={() => handleImgError(index)} onClick={commonProps.onClick} onLoad={commonProps.onLoad} />;
    $[12] = commonProps;
    $[13] = handleImgError;
    $[14] = imgErrorArr;
    $[15] = index;
    $[16] = isConverted;
    $[17] = isVideo;
    $[18] = item.coverImage;
    $[19] = item.url;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== isVideo) {
    t8 = isVideo && <VideoIcon className="pointer-events-none absolute bottom-[5px] left-[6px] h-[14px] w-[14px] 2xl:h-[16px] 2xl:w-[16px]" />;
    $[21] = isVideo;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = <div className="relative aspect-[16/9] flex-shrink-0 overflow-hidden rounded-lg" style={t4} key={t5} ref={t6}>{t7}{t8}</div>;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default TrailerThumbnailItem;